/**
 * Sums an account's monthly income or expense totals.
 *
 * Buckets each transaction by its OWN type (not merely the account side), so a
 * savings contribution debited from the account is not miscounted as an expense.
 * Internal transfers (flow === "transfer") are excluded — they move money
 * between the user's own accounts and are neither income nor expense. Month keys
 * are derived from the raw ISO date string (YYYY-MM) rather than a local Date so
 * UTC-stored timestamps do not drift across month boundaries.
 *
 * @param {Array} txs        Transactions touching the account (any order).
 * @param {string} accountId The account whose perspective we compute.
 * @param {"income"|"expense"} type Which cashflow bucket to total.
 * @returns {Object<string, number>} { [YYYY-MM]: total }
 */
export function computeMonthlyTotals(txs, accountId, type) {
  const monthlyTotals = {};
  (txs || []).forEach((tx) => {
    if (tx.flow === "transfer") return;
    if (String(tx.type || "").toLowerCase() !== type) return;

    const isCredit = accountId === tx.creditAccountId;
    const isDebit = accountId === tx.debitAccountId;
    const sideMatches =
      (type === "income" && isCredit) || (type === "expense" && isDebit);
    if (!sideMatches) return;

    const amount = Number(tx.amount);
    if (!Number.isFinite(amount) || amount === 0) return;

    const key = String(tx.date || "").slice(0, 7);
    if (key.length !== 7) return;
    monthlyTotals[key] = (monthlyTotals[key] || 0) + amount;
  });
  return monthlyTotals;
}
